import styled, { css } from 'styled-components'

export const ProfileBadgeRoot = styled.span<{
  $color?: string
  $compact?: boolean
}>`
  display: inline-flex;
  align-items: center;
  max-width: ${({ $compact }) => ($compact ? '80%' : '100%')};
  padding: ${({ $color }) => ($color && $color !== 'unset' ? '4px 6px' : '0')};
  border-radius: 8px;
  color: #363636;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

  ${({ $color }) =>
    $color && $color !== 'unset'
      ? css`
          background-color: ${$color}26;
          border: solid 1px ${$color}33;
        `
      : css`
          background-color: transparent;
          border: none;
        `}

  svg {
    color: #757575;
    margin-right: 4px;
    flex-shrink: 0;
    font-size: 12px;
  }
`

/** Contador "+N" cuando hay más perfiles de los visibles en celda compacta. */
export const ProfileOverflowBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 6px;
  margin: 1px 8px 0 0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #4c4c4c;
  background-color: #f0f0f0;
  border: solid 1px #d9d9d9;
`
